<template>
  <MoleculeLoginCallback/>
</template>

<script>
export default {
  name: 'OrganismLoginCallback',

  components: {
    MoleculeLoginCallback: () => import('@/components/molecules/MoleculeLoginCallback')
  }
}
</script>
